import { makeAutoObservable, runInAction } from 'mobx'
import { openApi } from '../../../helpers/request'
import { FormEvent } from 'react'
import { notification } from 'antd'
import i from '../../../translations/i'
import settingsController from "../orders/settings.controller";

interface ProjectInterface {
    id: number
    cities_enabled: boolean
    cities_view: number
    warehouses_enabled: boolean
    warehouses_view: number
    warehouses_show_other_warehouses: boolean
    warehouses_show_all_products: boolean
    warehouse_selection_type: string
    view_categories_level_1: number
    view_categories_level_2: number
    view_categories_level_3: number
    view_products: number
    view_products_in_home: number
    tab_bar_enabled: boolean
    import_action_elements: number
    default_dialing_code: string
    messenger_type: string
    telegram_bot_token: string
    web_header: string
    web_footer: string
    web_prefix: string
    web_postfix: string
    web_main_title: string
    web_main_description: string
    web_main_keywords: string
    web_favicon: any
    web_logotype_horizontal: any
    web_footer_app_image: any
    bonus: boolean
    welcome_bonus: boolean
    bonuses_expire: boolean,
    welcome_bonus_size: number,
    combustion_days: number,
    percent_bonus_cart: number,
    cashback_percent: number
    bonus_card: boolean,
    bonus_card_value: null | string
    bonus_card_type: string
    bonus_description: string | null
    delivery_intervals_enabled: boolean
    pickup_intervals_enabled: boolean
    express_delivery_intervals_enabled: boolean
    roadmap: boolean
    auto_order_cancellation: number,
    place_groups_view: number,
    onboarding_enabled: boolean,
    onboarding_view_type: number,
    promo_slide_enabled: boolean,
    promo_slide_view_type: number
    update_navigation_warehouse: boolean
    referral_system: boolean
    rf_points_inviting_count: number
    rf_points_inviting_burn: number
    rf_points_invited_count: number
    rf_points_invited_burn: number
    rf_condition: number
    rf_description: string | null
    referral_promo_code_title: string | null
    referral_promo_code_text: string | null
    referral_promo_code_share: string | null
    view_articles_level_1: number
    share_text: null | string
    deeplink: null | string
    code_receive_order_enabled: boolean
    code_receive_order_validity_enabled: boolean
    code_receive_order_type: string
    code_receive_order_format: string
    firebase_json: string | null
    hide_prices_un_users: boolean
    assembly_error: number
    product_view_types_images: number
    prohibit_registration: boolean
    scan_coupon_enabled: boolean
    scan_coupon_type: string
    scan_coupon_value: string
    share_product: boolean
    bonus_accrue_upon_write_off: boolean
    bonus_charge_old_price: boolean
    auto_select_variant: boolean
    text_for_blocked_user: string | null
    nearest_delivery: boolean
    order_check_number: boolean
    price_types_enabled: boolean
    default_type_price_id: null | number
    // Округление цен для покупателя: шаг (0 — выключено) и способ
    price_rounding_step?: number
    price_rounding_mode?: 'math' | 'down' | 'up'
    service_fee: boolean

    service_fee_name: string

    service_fee_description: string

    service_fee_amount: number

    service_fee_unit: number

    service_fee_min: null | number

    service_fee_max: null | number
    display_type_links_products: number
    email_send_to_clients: boolean
    catalog_label: null | string
    catalog_seo_title: null | string
    catalog_seo_description: null | string
    catalog_seo_keywords: null | string
    catalog_description: null | string
    no_write_points_old_price: boolean
    bonus_writeoff_reduces_min_order: boolean
    visible_points_list_products: boolean
    wh_sort_type: number
    order_max_weight: null | number
    tap_bar_view_type: number,
    upselling_view_type: number,
    web_noindex: boolean,
    item_card_popup: boolean
    use_tk: boolean
    search_suggestions: boolean
    weight_enabled: boolean
    web_header_view_type_cart: number
    web_header_view_type: number
    web_header_bg_file: any
    web_header_bg_pattern_file: any
    view_bonus_points: boolean
    new_search: boolean
    warehouse_select_require: boolean
    allow_adding_to_cart: boolean
    buy_button: null | string
}

class projectController {
    constructor() {
        makeAutoObservable(this)
    }

    user_super = false

    render: boolean = false

    project: ProjectInterface = {
        id: 0,
        cities_enabled: false,
        cities_view: 1,
        warehouses_enabled: false,
        warehouses_view: 1,
        warehouses_show_other_warehouses: false,
        warehouses_show_all_products: false,
        warehouse_selection_type: 'list',
        view_categories_level_1: 1,
        view_categories_level_2: 1,
        view_categories_level_3: 1,
        view_products: 1,
        view_products_in_home: 1,
        tab_bar_enabled: true,
        import_action_elements: 0,
        default_dialing_code: '+',
        messenger_type: 'telegram',
        telegram_bot_token: 'е',
        web_header: '',
        web_footer: '',
        web_prefix: '',
        web_postfix: '',
        web_main_title: '',
        web_main_description: '',
        web_main_keywords: '',
        web_favicon: null,
        web_logotype_horizontal: null,
        web_footer_app_image: null,
        bonus: false,
        welcome_bonus: false,
        bonuses_expire: false,
        welcome_bonus_size: 0,
        combustion_days: 0,
        percent_bonus_cart: 0,
        cashback_percent: 0,
        bonus_card: false,
        bonus_card_value: null,
        bonus_card_type: 'qrcode',
        bonus_description: null,
        delivery_intervals_enabled: true,
        pickup_intervals_enabled: true,
        express_delivery_intervals_enabled: true,
        roadmap: false,
        auto_order_cancellation: 0,
        place_groups_view: 1,
        onboarding_view_type: 1,
        onboarding_enabled: true,
        promo_slide_enabled: true,
        promo_slide_view_type: 1,
        update_navigation_warehouse: false,
        referral_system: false,
        rf_points_inviting_count: 0,
        rf_points_inviting_burn: 0,
        rf_points_invited_count: 0,
        rf_points_invited_burn: 0,
        rf_condition: 0,
        rf_description: null,
        referral_promo_code_title: null,
        referral_promo_code_text: null,
        referral_promo_code_share: null,
        view_articles_level_1: 1,
        share_text: null,
        deeplink: null,
        code_receive_order_enabled: false,
        code_receive_order_validity_enabled: false,
        code_receive_order_type: 'barcode',
        code_receive_order_format: '',
        firebase_json: null,
        hide_prices_un_users: false,
        product_view_types_images: 0,
        prohibit_registration: false,
        scan_coupon_enabled: false,
        scan_coupon_type: 'qr',
        scan_coupon_value: 'code',
        share_product: true,
        bonus_accrue_upon_write_off: true,
        bonus_charge_old_price: true,
        auto_select_variant: false,
        text_for_blocked_user: null,
        nearest_delivery: false,
        assembly_error: 10,
        order_check_number: false,
        price_types_enabled: false,
        default_type_price_id: null,
        service_fee: false,
        service_fee_name: '',
        service_fee_description: '',
        service_fee_amount: 0,
        service_fee_unit: 0,
        service_fee_min: null,
        service_fee_max: null,
        display_type_links_products: 0,
        email_send_to_clients: true,
        catalog_label: null,
        catalog_seo_title: null,
        catalog_seo_description: null,
        catalog_seo_keywords: null,
        catalog_description: null,
        no_write_points_old_price: false,
        bonus_writeoff_reduces_min_order: false,
        visible_points_list_products: true,
        wh_sort_type: 0,
        order_max_weight: null,
        tap_bar_view_type: 0,
        upselling_view_type: 0,
        web_noindex: false,
        item_card_popup: false,
        use_tk: false,
        search_suggestions: true,
        weight_enabled: true,
        web_header_view_type_cart: 0,
        web_header_view_type: 0,
        web_header_bg_file: null,
        web_header_bg_pattern_file: null,
        view_bonus_points: true,
        new_search: false,
        warehouse_select_require: false,
        allow_adding_to_cart: false,
        buy_button: null
    }

    bonusMassAssignment = false

    bonusMassAssignmentData: any = {
        bonuses_add: 0,
        bonuses_add_combustion_date: null
    }

    // Часовой пояс проекта живёт в kssettings, а не в project_settings
    timezone: string | null = null
    timezones: any[] = []

    isset = false

    get() {
        openApi('get', 'settings')
            .then(result => {
                console.log(result)
                runInAction(() => {
                    this.project = result.data.project
                    this.timezone = result.data.timezone ?? null
                    this.isset = true
                    this.render = true
                })
            })
    }

    getTimezones() {
        if (this.timezones.length > 0) return

        openApi('get', '/setting/timezones')
            .then(result => {
                runInAction(() => {
                    this.timezones = result.data
                })
            })
            .catch(error => console.log(error))
    }

    setTimezone(value: string | null) {
        this.timezone = value
    }

    save(e: FormEvent, saveOldSettings = false) {
        e.preventDefault()

        this.saving()
        if(saveOldSettings) settingsController.save(e)
    }

    saving() {
        let data = new FormData()

        if (this.timezone) data.append('timezone', this.timezone)
        data.append('cities_enabled', `${+ this.project.cities_enabled}`)
        data.append('cities_view', `${this.project.cities_view}`)
        data.append('warehouses_enabled', `${+ this.project.warehouses_enabled}`)
        data.append('warehouses_view', `${this.project.warehouses_view}`)
        data.append('warehouses_show_other_warehouses', `${+ this.project.warehouses_show_other_warehouses}`)
        data.append('warehouses_show_all_products', `${+ this.project.warehouses_show_all_products}`)
        data.append('warehouse_selection_type', this.project.warehouse_selection_type)
        data.append('warehouse_select_require', `${+ this.project.warehouse_select_require}`)
        data.append('view_categories_level_1', `${this.project.view_categories_level_1}`)
        data.append('view_categories_level_2', `${this.project.view_categories_level_2}`)
        data.append('view_categories_level_3', `${this.project.view_categories_level_3}`)
        data.append('view_articles_level_1', `${this.project.view_articles_level_1}`)
        data.append('view_products', `${this.project.view_products}`)
        data.append('view_products_in_home', `${this.project.view_products_in_home}`)
        data.append('place_groups_view', `${this.project.place_groups_view}`)
        data.append('tab_bar_enabled', `${+ this.project.tab_bar_enabled}`)
        data.append('import_action_elements', `${+ this.project.import_action_elements}`)
        data.append('default_dialing_code', this.project.default_dialing_code)
        data.append('messenger_type', this.project.messenger_type ?? 'telegram')
        data.append('telegram_bot_token', this.project.telegram_bot_token)
        data.append('web_header', this.project.web_header)
        data.append('web_footer', this.project.web_footer)

        data.append('web_prefix', this.project.web_prefix)
        data.append('web_postfix', this.project.web_postfix)
        data.append('web_main_title', this.project.web_main_title)
        data.append('web_main_description', this.project.web_main_description)
        data.append('web_main_keywords', this.project.web_main_keywords)

        data.append('web_favicon', this.project.web_favicon)
        data.append('web_logotype_horizontal', this.project.web_logotype_horizontal)
        data.append('web_footer_app_image', this.project.web_footer_app_image)

        data.append('bonus', `${+ this.project.bonus}`)
        data.append('welcome_bonus', `${+ this.project.welcome_bonus}`)
        data.append('bonuses_expire', `${+ this.project.bonuses_expire}`)
        data.append('welcome_bonus_size', `${this.project.welcome_bonus_size}`)
        data.append('combustion_days', `${this.project.combustion_days}`)
        data.append('percent_bonus_cart', `${this.project.percent_bonus_cart}`)
        data.append('cashback_percent', `${this.project.cashback_percent}`)
        data.append('bonus_card', `${+ this.project.bonus_card}`)
        data.append('bonus_card_value', this.project.bonus_card_value ?? '')
        data.append('bonus_card_type', `${this.project.bonus_card_type}`)
        data.append('bonus_description', this.project.bonus_description ?? '')

        data.append('delivery_intervals_enabled', `${+ this.project.delivery_intervals_enabled}`)
        data.append('pickup_intervals_enabled', `${+ this.project.pickup_intervals_enabled}`)
        data.append('express_delivery_intervals_enabled', `${+ this.project.express_delivery_intervals_enabled}`)
        data.append('update_navigation_warehouse', `${+ this.project.update_navigation_warehouse}`)

        data.append('roadmap', `${+ this.project.roadmap}`)
        data.append('auto_order_cancellation', `${this.project.auto_order_cancellation}`)

        data.append('onboarding_enabled', `${+ this.project.onboarding_enabled}`)
        data.append('onboarding_view_type', `${this.project.onboarding_view_type}`)
        data.append('promo_slide_enabled', `${+ this.project.promo_slide_enabled}`)
        data.append('promo_slide_view_type', `${this.project.promo_slide_view_type}`)

        data.append('referral_system', `${+ this.project.referral_system}`)
        data.append('rf_points_inviting_count', `${+ this.project.rf_points_inviting_count}`)
        data.append('rf_points_inviting_burn', `${+ this.project.rf_points_inviting_burn}`)
        data.append('rf_points_invited_count', `${+ this.project.rf_points_invited_count}`)
        data.append('rf_points_invited_burn', `${+ this.project.rf_points_invited_burn}`)
        data.append('rf_condition', `${+ this.project.rf_condition}`)
        if(this.project.rf_description) data.append('rf_description', this.project.rf_description)

        data.append('referral_promo_code_title', this.project.referral_promo_code_title ?? '')
        data.append('referral_promo_code_text', this.project.referral_promo_code_text ?? '')
        data.append('referral_promo_code_share', this.project.referral_promo_code_share ?? '')

        if(this.project.share_text) data.append('share_text', this.project.share_text)
        if(this.project.deeplink) data.append('deeplink', this.project.deeplink)

        data.append('code_receive_order_enabled', `${+ this.project.code_receive_order_enabled}`)
        data.append('code_receive_order_validity_enabled', `${+ this.project.code_receive_order_validity_enabled}`)
        data.append('code_receive_order_type', this.project.code_receive_order_type)
        data.append('code_receive_order_format', this.project.code_receive_order_format)

        if(this.project.firebase_json) data.append('firebase_json', this.project.firebase_json)

        data.append('hide_prices_un_users', `${+ this.project.hide_prices_un_users}`)
        data.append('product_view_types_images', `${+ this.project.product_view_types_images}`)

        data.append('prohibit_registration', `${+ this.project.prohibit_registration}`)

        data.append('scan_coupon_enabled', `${+ this.project.scan_coupon_enabled}`)
        data.append('scan_coupon_type', `${this.project.scan_coupon_type}`)
        data.append('scan_coupon_value', `${this.project.scan_coupon_value}`)

        data.append('share_product', `${+ this.project.share_product}`)

        data.append('bonus_accrue_upon_write_off', `${+ this.project.bonus_accrue_upon_write_off}`)
        data.append('bonus_charge_old_price', `${+ this.project.bonus_charge_old_price}`)

        data.append('auto_select_variant', `${+ this.project.auto_select_variant}`)

        data.append('nearest_delivery', `${+ this.project.nearest_delivery}`)

        if(this.project.text_for_blocked_user) data.append('text_for_blocked_user', this.project.text_for_blocked_user)
        data.append('assembly_error', `${+ this.project.assembly_error}`)
        data.append('order_check_number', `${+ this.project.order_check_number}`)
        data.append('price_types_enabled', `${+ this.project.price_types_enabled}`)
        if(this.project.default_type_price_id) data.append('default_type_price_id', `${+ this.project.default_type_price_id}`)
        // Старый сервер настройку не отдаёт — тогда и не шлём
        if (this.project.price_rounding_step !== undefined && this.project.price_rounding_step !== null) data.append('price_rounding_step', `${+ this.project.price_rounding_step}`)
        if (this.project.price_rounding_mode) data.append('price_rounding_mode', this.project.price_rounding_mode)


        data.append('service_fee', `${+ this.project.service_fee}`)
        data.append('service_fee_name', `${this.project.service_fee_name}`)
        data.append('service_fee_description', `${this.project.service_fee_description}`)
        data.append('service_fee_amount', `${+ this.project.service_fee_amount}`)
        data.append('service_fee_unit', `${+ this.project.service_fee_unit}`)
        data.append('service_fee_min', this.project.service_fee_min ? `${+ this.project.service_fee_min}` : '')
        data.append('service_fee_max', this.project.service_fee_max ? `${+ this.project.service_fee_max}` : '')

        data.append('display_type_links_products', `${this.project.display_type_links_products}`)

        data.append('email_send_to_clients', `${+ this.project.email_send_to_clients}`)

        data.append('catalog_label', `${this.project.catalog_label ?? ''}`)
        data.append('catalog_seo_title', `${this.project.catalog_seo_title ?? ''}`)
        data.append('catalog_seo_description', `${this.project.catalog_seo_description ?? ''}`)
        data.append('catalog_seo_keywords', `${this.project.catalog_seo_keywords ?? ''}`)
        data.append('catalog_description', `${this.project.catalog_description ?? ''}`)

        console.log(`${this.project.catalog_description ?? ''}`)

        data.append('no_write_points_old_price', `${+ this.project.no_write_points_old_price}`)
        data.append('bonus_writeoff_reduces_min_order', `${+ this.project.bonus_writeoff_reduces_min_order}`)
        data.append('visible_points_list_products', `${+ this.project.visible_points_list_products}`)

        data.append('wh_sort_type', `${+ this.project.wh_sort_type}`)
        data.append('order_max_weight', this.project.order_max_weight ? `${+ this.project.order_max_weight}` : '')

        data.append('tap_bar_view_type', `${+ this.project.tap_bar_view_type}`)
        data.append('upselling_view_type', `${+ this.project.upselling_view_type}`)
        data.append('web_noindex', `${+ this.project.web_noindex}`)
        data.append('item_card_popup', `${+ this.project.item_card_popup}`)
        data.append('use_tk', `${+ this.project.use_tk}`)
        data.append('search_suggestions', `${+ this.project.search_suggestions}`)
        data.append('weight_enabled', `${+ this.project.weight_enabled}`)

        data.append('web_header_view_type_cart', `${this.project.web_header_view_type_cart}`)
        data.append('web_header_view_type', `${this.project.web_header_view_type}`)
        data.append('web_header_bg_file', this.project.web_header_bg_file)
        data.append('web_header_bg_pattern_file', this.project.web_header_bg_pattern_file)

        data.append('view_bonus_points', `${+ this.project.view_bonus_points}`)
        data.append('new_search', `${+ this.project.new_search}`)

        data.append('allow_adding_to_cart', `${+ this.project.allow_adding_to_cart}`)
        data.append('buy_button', this.project.buy_button ?? '')

        openApi('post', 'settings', data)
            .then(result => {
                console.log(result)
                notification.success({
                    message: i.t('def:success.complete'),
                    description: i.t('def:success.edit')
                });
            })
            .catch(err => {
                console.log(err.response)
                notification.error({
                    message: i.t('def:errors.error'),
                    description: err.response?.data?.data?.message ?? i.t('def:errors.somethingWentWrong')
                });
            })
    }

    set(name: string, value: any, save: boolean = false) {
        //@ts-ignore
        this.project[name] = value

        if(save) this.saving()
    }

    clearAllCatalog() {
        openApi('post', '/shop/clear')
            .then(result => {
                console.log(result)
                notification.success({
                    message: i.t('def:success.complete'),
                    description: ''
                });
            })
    }

    openBonusMassAssignment() {
        this.bonusMassAssignment = true
        this.bonusMassAssignmentData = {
            bonuses_add: 0,
            bonuses_add_combustion_date: null
        }
    }

    saveBonusMassAssignment() {
        const data = new FormData()
        data.append('count_bonus', this.bonusMassAssignmentData.bonuses_add)
        if(this.bonusMassAssignmentData.bonuses_add_combustion_date) data.append('combustion_date', this.bonusMassAssignmentData.bonuses_add_combustion_date)

        openApi('post', `/bonus_program/mass_assignment`, data)
            .then(result => {
                console.log('success saveBonusMassAssignment')
                console.log(result)
                this.closeBonusMassAssignment()

                notification.success({
                    message: i.t('def:success.complete'),
                    description: i.t('def:Bonuses awarded to all users')
                })
            })
            .catch((err) => {
                console.log('error saveBonusMassAssignment')
            })
    }

    closeBonusMassAssignment() {
        this.bonusMassAssignment = false
        this.bonusMassAssignmentData = {
            bonuses_add: 0,
            bonuses_add_combustion_date: null
        }
    }

    reIndexCatalog() {
        if(window.confirm(i.t('def:reIndexCatalogConfirm'))) {
            openApi('post', '/settings/reindex_catalog')
                .then(res => {

                })
                .catch(err => {

                })
        }

    }

    handleChangeReceiveCode(e: string) {
        const newValue = e

        const regex = /^[NL-]*$/;
        if (regex.test(newValue) || newValue === "") {
            this.project.code_receive_order_format = newValue
        }
    }

    clickhouseReindex() {
        if(window.confirm(i.t('settings:project.clickhouseReindexConfirm'))) {
            openApi('post', '/protected/index')
                .then(res => {
                    notification.success({
                        message: i.t('def:success.complete'),
                        description: i.t('settings:project.clickhouseReindexed')
                    });
                })
                .catch(err => {
                    notification.error({
                        message: i.t('def:errors.error'),
                        description: i.t('def:errors.somethingWentWrong')
                    });
                })
        }
    }
}

export default new projectController()